// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "fdd47866" + "." + "02f6bac9e8ba0edc" + ".js";
};